<script>
import { mapActions } from "vuex";

import professionalMixin from "@/mixins/accountable/professionalMixin";

import Info from "./Info";
import Profile from "./Profile";
import Actions from "./Actions";
import Support from "./Banners/Support";
import Badges from "./Banners/Badges";

export default {
  mixins: [professionalMixin],

  components: {
    Info,
    Profile,
    Actions,
    Support,
    Badges
  },

  data() {
    return {
      showProfile: false
    };
  },

  props: {
    professional: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    shouldApplyFocus: {
      type: Boolean,
      required: true
    },
    index: {
      type: Number,
      required: false
    },
    sugestion: {
      type: Boolean,
      require: false,
      defalt: false
    }
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setProfessional",
      "unsetProfessional",
      "confirmProfessional"
    ]),

    toogleProfile() {
      if (!this.isSelected) {
        this.showProfile = true;
        this.setProfessional(this.professional.id);
      } else {
        this.showProfile = !this.showProfile;
        this.unsetProfessional();
      }
    },

    handleProfessionalSelection() {
      this.setProfessional(this.professional.id);
      this.confirmProfessional();
    }
  },

  watch: {
    isSelected(newValue) {
      if (!newValue) {
        this.showProfile = false;
      }
    }
  }
};
</script>

<template>
  <div>
    <div
      class="professional-card"
      :class="{ 'focused': isSelected, 'not-selected': shouldApplyFocus && !this.isSelected }"
    >
      <Info
        :professionalId="professional.id"
        :profilePicture="professional | profilePicture"
        :fullName="professional | shorterFullName"
        :orderCount="professional | orderCount"
        :rating="professional | rating"
        :feedbacks="professional | feedbacks"
        :coupon="professional | coupon"
        :topProfessional="professional | topProfessional"
        :highDemand="professional | highDemand"
        :sugestion="sugestion"
        @toogleProfile="toogleProfile"
      />

      <transition name="zoom" mode="out-in">
        <Profile
          :isSelected="isSelected && showProfile"
          :bio="professional | bio"
          :latestFeedback="professional | latestFeedback"
        />
      </transition>

      <Actions
        :profileOpened="showProfile"
        :fullName="professional | firstName"
        @toogleProfile="toogleProfile"
        @selectProfessional="handleProfessionalSelection"
      />
    </div>

    <Support v-if="index === 2" />
    <Badges v-if="index === 7" />
  </div>
</template>

<style scoped>
.professional-card {
  margin: 0 auto;
  border: solid 1px #f2f2f2;
  border-radius: 2px;
  transition: border 0.25s ease-in-out, opacity 0.25s ease-in-out;
  position: relative;
}

.focused {
  border: solid 2px #603295;
}

.not-selected {
  opacity: 0.25;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Index.vue